<template>
  <div class="empty-state">
    <slot />
  </div>
</template>

<script>
  export default { name: 'EmptyState' }
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 28px 0;
  color: rgba(0, 0, 0, 0.35);
  font-size: 0.875rem;
}
</style>
